import React, { Component } from 'react';
import Swal from 'sweetalert2';
import instance from './axios-instance';
import Systems from './SystemFunction';
const CDN = 'https://baryon.million-edge.online/public/html/default_whitelabel/shared-image/lucky_wheel/beta-cny';
const WINNER_BG = `${CDN}/winner-bg.png`;

/* ── Injected CSS ── */

/* ── Mock recent winners ── */
const MOCK_WINNERS = [
  { date: '25/05', name: 'p*****k', amount: 'THB 50' },
  { date: '25/05', name: 'k*****2', amount: 'THB 10' },
  { date: '25/05', name: 'n*****8', amount: 'THB 10' },
  { date: '25/05', name: 'a*****5', amount: 'THB 30' },
  { date: '25/05', name: 's*****1', amount: 'THB 10' },
  { date: '25/05', name: 'w*****0', amount: 'THB 10' },
  { date: '24/05', name: 'j*****9', amount: 'THB 10' },
  { date: '24/05', name: 'm*****3', amount: 'THB 100' },
  { date: '24/05', name: 't*****7', amount: 'THB 50' },
  { date: '23/05', name: 'r*****4', amount: 'THB 30' },
  { date: '23/05', name: 'b*****2', amount: 'THB 10' },
  { date: '22/05', name: 'c*****6', amount: 'THB 200' },
];

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];

const PRIZE_ITEMS = [
  { name: 'iPhone 17 Pro Max', emoji: '📱' },
  { name: 'iPhone 17 Air', emoji: '📱' },
  { name: 'เครดิตฟรี 288 บาท', emoji: '💰' },
  { name: 'เครดิตฟรี 499 บาท', emoji: '💰' },
  { name: 'เครดิตฟรี 100 บาท', emoji: '💰' },
  { name: 'เครดิตฟรี 50 บาท', emoji: '💰' },
  { name: 'เครดิตฟรี 30 บาท', emoji: '💰' },
  { name: 'เครดิตฟรี 20 บาท', emoji: '💰' },
  { name: 'เครดิตฟรี 10 บาท', emoji: '💰' },
];

const getPrizeDisplayName = (item, index = 0) => {
  const rawName =
    item?.description ||
    item?.name ||
    item?.prize_name ||
    item?.prizename ||
    item?.reward_name ||
    item?.rewardName ||
    item?.title ||
    item?.label ||
    item?.text ||
    '';

  if (rawName) return String(rawName);

  const amount =
    item?.amount ||
    item?.price ||
    item?.credit ||
    item?.bonus ||
    item?.value ||
    item?.cash ||
    item?.reward_value ||
    '';

  if (amount) return `เครดิตฟรี ${amount}`;

  return PRIZE_ITEMS[index]?.name || `รางวัล ${index + 1}`;
};

const normalizePrizeItem = (item, index = 0) => ({
  ...item,
  id: item?.id ?? item?._id ?? item?.key ?? index,
  name: getPrizeDisplayName(item, index),
  image: item?.image || item?.img || item?.img_path || item?.imagepath || item?.picture || '',
});


class LuckyWheelPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      point: props.point || 0,
      userid: props.userid || '',
      tblwheelsetting: [],
      currentPosition: 0,
      isSpinning: false,
      segments: [],
      winnerTab: 'list',
      winnerIndex: -1,
    };
    this._slideInterval = null;
  }

  componentDidMount() {
    this.getwheel();
    this.startWinnerSlide();
  }

  componentWillUnmount() {
    if (this._slideInterval) clearInterval(this._slideInterval);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.point !== this.props.point) this.setState({ point: this.props.point || 0 });
    if (prevProps.userid !== this.props.userid) this.setState({ userid: this.props.userid || '' });
  }

  /* Auto-scroll winner list upward like BK8 */
  startWinnerSlide() {
    this._slideInterval = setInterval(() => {
      const tbody = document.getElementById('winning-record-body');
      if (!tbody) return;
      if (tbody.scrollTop + tbody.clientHeight >= tbody.scrollHeight) {
        tbody.scrollTop = 0;
      } else {
        tbody.scrollTop += 1;
      }
    }, 40);
  }

  handleNav(to, e) {
    if (e?.preventDefault) e.preventDefault();
    if (e?.metaKey || e?.ctrlKey || e?.shiftKey || e?.altKey || e?.button === 1) return;
    if (typeof this.props.onNavigate === 'function') {
      this.props.onNavigate(to, e);
    } else {
      window.history.pushState(null, '', to);
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  }

  getwheel = async () => {
    try {
      const res = await instance.post('/api/v1/getwheelspin', { System: Systems });
      if (res.data.status !== 200) return;
      const datas = res.data.message || [];
      const tblwheelsetting = res.data.tblwheelsetting || [];
      if (tblwheelsetting.length > 0 && Number(tblwheelsetting[0].status) === 0) {
        await Swal.fire({ icon: 'error', title: 'เกมยังไม่เปิดให้บริการ', confirmButtonText: 'ตกลง' });
        this.handleNav('/');
        return;
      }
      const segments = Array.isArray(datas)
        ? datas.map((item, index) => normalizePrizeItem(item, index))
        : [];
      this.setState({ tblwheelsetting, segments });
    } catch (err) {
      console.log('[WHEEL:GET_ERROR]', err);
    }
  };

  spinWheel = (reward, rewardKey, eventBalance) => {
    const { currentPosition } = this.state;
    // hardcode 9 ให้ตรงกับ inner-wheel-9.png เสมอ
    const total = 9;
    const sliceDeg = 360 / total; // = 40°
    const rewardIndex = Number(rewardKey) - 1; // API ส่ง 1-based
    if (rewardIndex < 0 || rewardIndex >= total) return;

    const baseSpin = 6 * 360;
    // segment 0 ของรูปอยู่ที่ TOP (0°) → center ช่อง i = i * sliceDeg
    const targetAngle = rewardIndex * sliceDeg;

    // คำนวณตำแหน่งปัจจุบัน mod 360 เพื่อให้ spin ที่ 2+ ตรงเสมอ
    const currentMod = ((currentPosition % 360) + 360) % 360;
    const needRotate = (360 - ((targetAngle + currentMod) % 360)) % 360;
    const nextPosition = currentPosition + baseSpin + needRotate;

    const spinner = document.getElementById('lw-wheelSpinner');
    if (spinner) {
      // 228px, 240px = center ของ inner-wheel-9.png ใน container 457×481
      spinner.style.transformOrigin = '228px 240px';
      spinner.style.transition = 'transform 7s cubic-bezier(.12,.78,.18,1)';
      spinner.style.transform = `rotate(${nextPosition}deg)`;
    }

    setTimeout(() => {
      this.setState({
        currentPosition: nextPosition,
        isSpinning: false,
        point: eventBalance,
        winnerIndex: rewardIndex, // ไฮไลต์ช่องชนะด้วยสีทอง
      });
      Swal.fire({
        icon: 'success',
        title: 'ขอแสดงความยินดี 🎉',
        text: reward.name,
        imageUrl: reward.image || undefined,
        confirmButtonText: 'ตกลง',
      });
    }, 7200);
  };

  handleSpinWheel = async (e) => {
    if (e) e.preventDefault();
    if (this.state.isSpinning) return;
    if (this.state.point <= 0) {
      await Swal.fire({ icon: 'warning', title: 'ตั๋วไม่พอ', text: 'คุณไม่มีสปินสำหรับหมุนกงล้อ', confirmButtonText: 'ตกลง' });
      return;
    }
    const token = localStorage.getItem('auth_token');
    if (!token) {
      await Swal.fire({ icon: 'warning', title: 'กรุณาเข้าสู่ระบบ', confirmButtonText: 'ตกลง' });
      this.handleNav('/login');
      return;
    }
    this.setState({ isSpinning: true });
    try {
      const res = await instance.post('/api/v1/postwheelspin', { token, System: Systems });
      const { reward_key, event_balance, reward } = res.data;
      if (!reward) throw new Error('no reward');
      this.spinWheel(reward, reward_key, event_balance);
    } catch (err) {
      console.log('[WHEEL:SPIN_ERROR]', err);
      this.setState({ isSpinning: false });
      await Swal.fire({ icon: 'error', title: 'หมุนกงล้อไม่สำเร็จ', text: 'กรุณาลองใหม่อีกครั้ง', confirmButtonText: 'ตกลง' });
    }
  };

  getDisplayPrizes() {
    const { segments } = this.state;
    const source = Array.isArray(segments) && segments.length > 0 ? segments : [];

    /*
      inner-wheel-9.png has 9 fixed sectors.
      Always render 9 prize slots so labels match the wheel image.
      If API returns less than 9, fill the rest with default PRIZE_ITEMS.
      If API returns more than 9, only the first 9 are shown on the wheel.
    */
    const fixedSlots = Array.from({ length: 9 }).map((_, index) => {
      const item = source[index] || PRIZE_ITEMS[index] || { name: `รางวัล ${index + 1}`, emoji: '🎁' };
      return normalizePrizeItem(item, index);
    });

    return fixedSlots;
  }
renderPrizeLabels() {
  const prizes = this.getDisplayPrizes();
  if (!prizes?.length) return null;
  const { winnerIndex } = this.state;

  // geometry ของกงล้อ
  const cx = 228;
  const cy = 240;

  // ระยะ label จากจุดกลาง
  const radius = 132;

  // inner-wheel-9.png = 9 ช่อง
  const total = 9;
  const sliceDeg = 360 / total;

  return prizes.slice(0, 9).map((item, index) => {

    // segment 0 อยู่ที่ TOP → center ของช่อง i = i * sliceDeg
    const angle = index * sliceDeg;

    // แปลงเป็น radian (offset -90 เพื่อให้ช่องแรกอยู่บน)
    const rad = (angle - 90) * Math.PI / 180;

    // position รอบวง
    const x = cx + radius * Math.cos(rad);
    const y = cy + radius * Math.sin(rad);

    // เอียงข้อความตามแนวรัศมี
    let rotate = angle - 90;

    // กันข้อความกลับหัว
    if (rotate > 90) {
      rotate -= 180;
    }

    const isWinner = index === winnerIndex;
    return (
      <li
        key={`wheel-prize-${index}`}
        className="wheel-prize-label"
        style={{
          left: `${x}px`,
          top: `${y}px`,
          transform: `translate(-50%, -50%) rotate(${rotate}deg)`,
        }}
      >
        <span
          className="prize-label-text"
          style={isWinner ? {
            animation: 'wheelWinnerBlink 0.45s step-start infinite',
            color: '#FFD700',
            fontWeight: 'bold',
          } : {}}
        >
          {item.name}
        </span>
      </li>
    );
  });
}
  render() {
    const { point, isSpinning, winnerTab } = this.state;
    const blinkStyle = `@keyframes wheelWinnerBlink { 0%,49%{opacity:1} 50%,100%{opacity:0} }`;
    const canSpin = !isSpinning && point > 0;

    return (
      <div className="lw-page">
        <style dangerouslySetInnerHTML={{ __html: blinkStyle }} />
        <div className="lw-content">
          {/* ── Top bar ── */}
          <div className="lw-topbar">
            <button className="lw-back-btn" onClick={(e) => this.handleNav('/', e)}>←</button>
            <div className="lw-title">🎡 วงล้อนำโชค</div>
            <button className="lw-history-btn">ประวัติ</button>
          </div>

          {/* ── Main layout ── */}
          <div className="lucky-wheel-landing-container beta-cny" style={{ overflowX: 'visible' }}>
            <div className="container-row-1">

              {/* ══ LEFT: Wheel ══ */}
              <div className="lucky-wheel-wrapper">

                {/* Flags — icon-1=RIGHT, icon-2=LEFT (BK8 exact) */}
                <img src={`https://s3.newworld.center/image/e12073aa-0c4c-481f-ac9d-df35ac78ff62.webp`} alt="" className="icon-1" />
                <img src={`https://s3.newworld.center/image/e12073aa-0c4c-481f-ac9d-df35ac78ff62.webp`} alt="" className="icon-2" />

                {/* Crystals/Lanterns */}
                <img src={`${CDN}/crystal-1.png`} alt="" className="icon-3" />
                <img src={`${CDN}/crystal-2.png`} alt="" className="icon-4" />
                <img src={`${CDN}/crystal-3.png`} alt="" className="icon-5" />
                <img src={`${CDN}/crystal-4.png`} alt="" className="icon-6" />

                {/* Fireworks */}
                <img src={`${CDN}/big-firework.gif`}   alt="" className="firework-top" />
                <img src={`${CDN}/small-firework.gif`} alt="" className="firework-left" />
                <img src={`${CDN}/big-firework.gif`}   alt="" className="firework-right" />
                <img src={`${CDN}/small-firework.gif`} alt="" className="firework-bottom" />

                {/* ① Spinner — absolute, behind frame, z:2 */}
                <div id="lw-wheelSpinner">
                  <img src={`${CDN}/inner-wheel-9.png`} className="inner-wheel" alt="wheel" />
                  <ul className="prize-name-list">
                    {this.renderPrizeLabels()}
                  </ul>
                </div>

                {/* ② Frame GIF — relative, sets wrapper height, z:5 */}
                <img src={`${CDN}/lucky-wheel-outer-frame.gif`} alt="" className="lucky-wheel-frame" />

                {/* ③ Spin button — absolute, z:6 */}
                <button
                  className={`spin-icon${canSpin ? '' : ' disabled'}`}
                  onClick={canSpin ? this.handleSpinWheel : undefined}
                  disabled={!canSpin}
                >
                  <img src={`${CDN}/spin-button.png`} alt="SPIN" />
                </button>

                {/* ④ Spin content — absolute below frame */}
                <div className="spin-content">
                  <button
                    className="spin-content-btn"
                    onClick={canSpin ? this.handleSpinWheel : undefined}
                    disabled={!canSpin}
                  >
                    {isSpinning ? '⏳ กำลังหมุน...' : 'หมุนที่นี่'}
                  </button>
                  <p className="spin-content-reminder-title">
                    คุณมี {point} สปินที่ใช้ได้
                  </p>
                  <div className="lucky-wheel-btm-img">
                    <img src={`${CDN}/lucky-wheel-bottom.png`} alt="" />
                  </div>
                </div>

              </div>{/* end lucky-wheel-wrapper */}

              {/* ══ RIGHT: Winner panel ══ */}
              <div className="winner-content">
                <div className="winner-detail-with-bg beta-cny">
                  {/* Real img tag — CDN loads correctly via img src, CSS url() gets proxied to localhost */}
                  <img src={WINNER_BG} alt="" className="winner-bg-img" />
                  <p className="winner-header">🏆 ผู้ชนะล่าสุด</p>
                  <div className="detail-type">
                    <button
                      className={winnerTab === 'list' ? 'active' : ''}
                      onClick={() => this.setState({ winnerTab: 'list' })}
                    >รายชื่อผู้ชนะ</button>
                    <button
                      className={winnerTab === 'record' ? 'active' : ''}
                      onClick={() => this.setState({ winnerTab: 'record' })}
                    >บันทึกชัยชนะ</button>
                  </div>
                  <table className="winner-table">
                    <tbody id="winning-record-body" className="list-body">
                      {MOCK_WINNERS.map((w, i) => (
                        <tr key={i}>
                          <td style={{ width: 48 }}>{w.date}</td>
                          <td>
                            <span className="winner-name">{w.name}</span>
                            <span className="winner-amt">{w.amount}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

            </div>{/* end container-row-1 */}

            {/* ══ Prize cards + T&C ══ */}
            <div className="tnc-container" style={{ overflowX: 'visible' }}>
              {/* Prize cards — use segments from API when loaded, fallback to PRIZE_ITEMS */}
              <div className="prize-cards-row" style={{ overflowX: 'auto', paddingLeft: 16, paddingRight: 16 }}>
                {this.getDisplayPrizes().map((prize, i) => {
                  const level = i + 1;
                  return (
                    <div className={`prize-${level}`} key={prize.id || i}>
                      <div className="prize-container">
                        <img
                          loading="lazy"
                          src={`${CDN}/prize/prize-level${Math.min(level, 8)}.png`}
                          className="prize-level"
                          alt="prize-level"
                        />

                        {prize.image ? (
                          <img
                            loading="lazy"
                            src={prize.image}
                            className="prize"
                            alt={prize.name}
                          />
                        ) : (
                          <span className="prize prize-empty">{prize.emoji || '🎁'}</span>
                        )}

                        <p>{prize.name || prize.description || ''}</p>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Terms & Conditions */}
              <div className="lw-terms">
                <div className="lw-terms-header">
                  <h3>📜 ข้อกำหนดและเงื่อนไข</h3>
                </div>
                <div className="lw-terms-body">
                  <div className="lw-terms-text">
                    <p className="lw-terms-subtitle">ชื่อโปรโมชั่น: วงล้อสีชงโค</p>
                    <p className="lw-terms-subtitle" style={{ marginTop: 10 }}>วิธีการรับโปรโมชั่น:</p>
                    <ul>
                      {[
                        'โปรโมชั่นนี้สำหรับสมาชิกที่ฝากเงิน THB เท่านั้น',
                        'รางวัลที่ได้รับจาก Lucky Wheel จะโอนไปยังบัญชีสมาชิก ต้อง Turnover 1 เท่าก่อนถอน',
                        'สมาชิกทุกคนได้รับสิทธิ์หมุน 1 ครั้ง/วัน',
                        'ฝากขั้นต่ำ 500 บาทจึงเข้าร่วมได้',
                        'มอบรางวัล 6 รางวัลต่อเดือน',
                        'ของรางวัลจริงรับภายใน 7–14 วันทำการ',
                      ].map((term, i) => (
                        <li key={i}>{term}</li>
                      ))}
                    </ul>
                    <p className="lw-terms-subtitle">ข้อกำหนดและเงื่อนไข:</p>
                    <ul>
                      {[
                        'ภาพถ่ายของรางวัลเป็นเพียงภาพอ้างอิง',
                        'PK8 ขอสงวนสิทธิ์เปลี่ยนแปลงรางวัลตามความเหมาะสม',
                        'เป็นไปตามข้อกำหนดและเงื่อนไขทั่วไปของ PK8',
                      ].map((term, i) => (
                        <li key={i}>{term}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="lw-terms-char">🎁</div>
                </div>
              </div>
            </div>

          </div>{/* end lucky-wheel-landing-container */}
        </div>{/* end lw-content */}
      </div>
    );
  }
}

export default LuckyWheelPage;
